<template>
  <div>
    <div class="row">
      <div class="col-6 col-md-6">
         <router-link tag="div" to="/residuos/embalagens">
          <div class="card text-center" :class="isActive('/residuos/embalagens')">
            <div class="card-body">
              <i class="material-icons icone">flip_to_front</i>
              <p class="card-text">Embalagens Vazias</p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-6 col-md-6">
         <router-link tag="div" to="/residuos/coleta">
          <div class="card text-center" :class="isActive('/residuos/coleta')">
            <div class="card-body">
              <i class="material-icons icone">local_shipping</i>
              <p class="card-text">Coleta Voluntária</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <router-view></router-view>

  </div>
</template>

<script>
import ls from 'local-storage';

export default {
  methods: {
    isActive(path) {
      const isIt = this.$route.fullPath.indexOf(path) > -1;
      return { 'bg-success': isIt, 'text-white': isIt };
    }
  }
};
</script>

<style scoped>
.icone {
  font-size: 50px;
}

.card {
  font-size: 10pt;
  cursor: pointer;
}

.col-4 {
  padding: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/app/residuos/Home.vue